import { Props } from './types';

const FieldError = ({ message }: Props) => {
  if (message) {
    return <p className="text-red-600">{message}</p>;
  }

  return null;
};

export default FieldError;
